"user client";

import { usePathname } from "next/navigation";
// pages/_app.js
import { useEffect } from "react";

import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

export default function PosthogAnalyticsProvider({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();

    useEffect(() => {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY ?? "", {
            ui_host: "https://eu.posthog.com",
            api_host: "https://eu.i.posthog.com",
            // don't capture analytics on localhost
            opt_out_capturing_by_default: window.location.hostname.endsWith("localhost"),
            capture_pageleave: true,
        });
    }, []);

    const { user: userProfile } = useGetLoggedInUser();

    useEffect(() => {
        // Identify user as soon as possible
        if (userProfile?.id != null) posthog.identify(userProfile.id);
    }, [userProfile?.id]);

    useEffect(() => {
        function getCookie(name: string) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop()?.split(";").shift();
        }
        const adminReplaceUser = getCookie("talentirAdminUserReplace");

        if (adminReplaceUser != null) {
            console.log("Posthog: Opting out of capturing");
            posthog.opt_out_capturing();
            return;
        }

        if (adminReplaceUser == null && !window.location.hostname.endsWith("localhost")) {
            console.log("Posthog: Opting in to capturing");
            posthog.opt_in_capturing();
        }

        void userProfile?.id;
    }, [userProfile?.id]);

    useEffect(() => {
        void pathname;
        // Track page views
        posthog.capture("$pageview");
    }, [pathname]);

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
